import { render, staticRenderFns } from "./integralrule.vue?vue&type=template&id=f23e53f0&scoped=true&"
import script from "./integralrule.vue?vue&type=script&lang=js&"
export * from "./integralrule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23e53f0",
  null
  
)

export default component.exports